import { useState, useEffect, useRef } from 'react';

// TODO AIFOLLOWUP
// TODO: Follow up with design on final container breakpoint values
// Also -- discuss use of enums
export let Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint[Breakpoint["Small"] = 320] = "Small";
  Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
  return Breakpoint;
}({});
export const useContainerBreakpoints = () => {
  const ref = useRef(null);
  const [breakpoint, setBreakpoint] = useState(Breakpoint.Small);
  useEffect(() => {
    if (ref.current) {
      const currentRef = ref.current;
      const updateWidth = entries => {
        for (const entry of entries) {
          const width = entry.contentRect.width;
          if (width <= Breakpoint.Small) {
            setBreakpoint(Breakpoint.Small);
          } else {
            setBreakpoint(Breakpoint.Large);
          }
        }
      };
      const resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(currentRef);
      return () => {
        resizeObserver.unobserve(currentRef);
      };
    }
  }, []);
  return {
    ref,
    breakpoint
  };
};